import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Slide,
  AppBar,
  Toolbar,
  Skeleton,
  Select,
  MenuItem,
  FormControl,
  FormControlLabel,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ProvisionPopup(props) {
  const { open, handlePopupClose, tp } = props;

  const [content, setContent] = useState("");
  const [seq, setSeq] = useState("");
  const [termList, setTermList] = useState([]);
  const [selectedTerm, setSelectedTerm] = useState("");

  // useEffect(() => {
  //   if (open) {
  //     axios.get(`api/op/provision/get-rfct/${tp}`).then((res) => {
  //       setContent(res.data.data.cont);
  //     });
  //   }
  // }, [open]);

  useEffect(() => {
    if (open) loadTermList();
  }, [open]);

  const loadTermList = () => {
    axios.get(`/api/op/provision`, { params: { schTp: tp } }).then(res => {
      if (res.data.data.provisionList) {
        setTermList(res.data.data.provisionList);

        let findItem = _.find(res.data.data.provisionList, item => {
          return item.rfctYn == "Y";
        });

        setSelectedTerm(findItem.seq);
        setContent(findItem.cont);
      }
    });
  };

  const findTerm = e => {
    let findItem = _.find(termList, item => {
      return item.seq == e.target.value;
    });
    setSelectedTerm(e.target.value);
    setContent(findItem.cont);
  };

  const getTitle = useMemo(() => {
    if (tp === 1) return "개인정보 수집 및 이용";
    if (tp === 2) return "이용약관";
    if (tp === 3) return "개인정보처리방침";
    if (tp === 4) return "영상정보처리기기운영·관리방침";
  }, [tp]);

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handlePopupClose}
      TransitionComponent={Transition}
      className="policy-wrap"
    >
      <AppBar>
        <Toolbar>
          <h2 className="h2">{getTitle}</h2>
          <IconButton aria-label="close" className="btn-close" onClick={handlePopupClose}>
            <span className="hidden">닫기</span>
          </IconButton>
        </Toolbar>
      </AppBar>
      <DialogContent>
        <Box className="box-type-1">
          <Box pb={6}>
            <FormControl>
              <Select displayEmpty value={selectedTerm} onChange={findTerm}>
                {termList.map((item, i) => (
                  <MenuItem key={i} value={item.seq}>
                    {item.ttl}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          {tp ? (
            <div
              dangerouslySetInnerHTML={{
                __html: content,
              }}
            />
          ) : (
            <>
              {/* {Array.from(Array(3)).map((_, index) => (
                <Fragment key={index}>
                  <Skeleton height={45} width={150} />
                  <Skeleton height={40} width={100} />
                  <Skeleton height={150} />
                </Fragment>
              ))} */}
            </>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
